// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"120":"314f0ff4","478":"30a444c9","491":"5227ff75","921":"b1e507d4","995":"ee73ee9e"}[chunkId] + ".js";
};